import CamelCase from './components/CamelCase';

export default CamelCase;
